import { User } from './types/User';
import { MakeCall } from './createMakeCall';

const facebookLogin = (makeCall: MakeCall) => (code: string) =>
  makeCall<User>('POST', `/api/v2/action/facebook-login`, {
    data: { code },
  });

export { facebookLogin };
